module.exports = __webpack_public_path__ + "static/media/product.297b6525.png";